import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { ModalProps } from '../types'
import './index.css'
import { holidaySchema } from '../../schema'
import { useAppDispatch } from '../../../../redux/hook'
import { addHoliday } from '../../api'
import { addholiday } from '../../slice/holidayslice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'

interface holidayFormValues {
    holidayName?: string
    holidayDate: string
    title?: string
}
const AddHoliday = ({ show, onClose }: ModalProps) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Add New Holiday"
            body={
                <Formik
                    initialValues={{
                        title: '',
                        holidayDate: '',
                    }}
                    validationSchema={holidaySchema}
                    onSubmit={async (
                        values,
                        actions: FormikHelpers<holidayFormValues>
                    ) => {
                        dispatch(SHOW_LOADER())
                        const dateObj = new Date(values.holidayDate)
                        // Get the day name from the Date object
                        const options: Intl.DateTimeFormatOptions = {
                            weekday: 'long',
                        }
                        const dayName = new Intl.DateTimeFormat(
                            'en-US',
                            options
                        ).format(dateObj)
                        const payload = {
                            holidayName: values.title as string,
                            holidayDate: new Date(values.holidayDate),
                            title: values.title as string,
                        }

                        try {
                            const response = await addHoliday(payload)
                            dispatch(
                                addholiday({
                                    id: response.data,
                                    payload,
                                    dayName,
                                })
                            )
                            dispatch(
                                SHOW_NOTIFICATION({
                                    message: 'Holiday added successfully',
                                    type: 'success',
                                })
                            )
                        } catch (err) {
                            // Handle any errors here
                            console.error('Error fetching holidays:', err)
                        } finally {
                            dispatch(HIDE_LOADER())
                        }
                        actions.setSubmitting(false)
                        onClose(false)
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="bg-green-color ">
                                <InputField
                                    type="text"
                                    name="title"
                                    lable="Holiday name"
                                    value={values.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.title}
                                    placeholder="Holiday Name"
                                    touched={touched.title}
                                />
                            </div>
                            <div className="bg-green-color calendar">
                                <InputField
                                    type="date"
                                    name="holidayDate"
                                    lable="Date"
                                    value={values.holidayDate}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.holidayDate}
                                    touched={touched.holidayDate}
                                />
                            </div>
                            <div className="footer-block">
                                <Button disabled={isSubmitting} type="submit">
                                    Add Holiday
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="submit"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default AddHoliday
